type ReportParams = {
  id?: string;
  group_id: string;
  index?: number;
  report_name?: string,
  sort_by?: string | null,
  group_by?: string,
  item_filter?: object | null,
  collection_filter?: object | null,
  hidden_columns?: object,
  show_total_area?: boolean,
  show_total_collection_area?: boolean,
  show_total_units?: boolean,
  show_untyped_items?: boolean,
  show_total_perimeter?: boolean,
  show_total_categories?: boolean,
  show_total_edge_treatment?: boolean,
  show_total_width?: boolean,
  show_total_height?: boolean,
  show_categories_with_no_items?: boolean,
  category_callout?: string,
  link_destination?: string | null,
  default_type_view?: number,
  count_method?: string,
  count_document_id?: string | null,
  count_sheet_section?: string | null,
  count_location_category?: string | null,
  collection_count_method?: string,
  collection_count_document_id?: string | null,
  collection_count_sheet_section?: string | null,
  collection_count_location_category?: string | null,
  multiply_contained_item_counts?: boolean,
  show_collection_cut_sheets?: boolean,
  show_item_cut_sheets?: boolean,
};

function createReport({
  id = crypto.randomUUID(),
  group_id,
  index = 0,
  report_name = 'Report',
  sort_by = null,
  group_by = 'type',
  item_filter = null,
  collection_filter = null,
  hidden_columns = {
    scope: true,
  },
  show_total_area = true,
  show_total_collection_area = false,
  show_total_units = true,
  show_untyped_items = true,
  show_total_perimeter = true,
  show_total_categories = false,
  show_total_edge_treatment = true,
  show_total_width = false,
  show_total_height = false,
  show_categories_with_no_items = true,
  category_callout = 'area',
  link_destination = null,
  default_type_view = 1,
  count_method = 'direct_entry',
  count_document_id = null,
  count_sheet_section = null,
  count_location_category = null,
  collection_count_method = 'direct_entry',
  collection_count_document_id = null,
  collection_count_sheet_section = null,
  collection_count_location_category = null,
  multiply_contained_item_counts = false,
  show_collection_cut_sheets = false,
  show_item_cut_sheets = true,
}: ReportParams) {
  return {
    id,
    group_id,
    index,
    report_name,
    sort_by,
    group_by,
    item_filter,
    collection_filter,
    hidden_columns,
    show_total_area,
    show_total_collection_area,
    show_total_units,
    show_untyped_items,
    show_total_perimeter,
    show_total_categories,
    show_total_edge_treatment,
    show_total_width,
    show_total_height,
    show_categories_with_no_items,
    category_callout,
    link_destination,
    default_type_view,
    count_method,
    count_document_id,
    count_sheet_section,
    count_location_category,
    collection_count_method,
    collection_count_document_id,
    collection_count_sheet_section,
    collection_count_location_category,
    multiply_contained_item_counts,
    show_collection_cut_sheets,
    show_item_cut_sheets,
  };
}

export { createReport };
